module.exports = __webpack_public_path__ + "img/pagsmile-v3-white.598ad4b.png";